/**
 * Error tag prefixes used by the tensorflow worker to mark specific
 * known failure modes. The main thread checks for these prefixes to
 * route errors to the right Sentry category without string-matching
 * on third-party library messages.
 */
export const WORKER_ERROR_TAGS = {
  WEBGL_SHADER: '[WEBGL_SHADER_ERROR]',
  YOLO_EMPTY_LIST: '[YOLO_EMPTY_LIST]',
  /**
   * Thrown by the YOLO score loop when more than half the candidate scores
   * are non-finite (NaN / +/-Infinity). This indicates the WebGL backend has
   * silently degraded - common on iOS Safari when F16 textures overflow or
   * the GPU is under memory pressure - and the model is producing garbage
   * even though no shader error has fired. Recovery: trigger a backend reset.
   */
  NAN_SCORES: '[YOLO_NAN_SCORES]',
} as const;
